import { queryOptions } from '@tanstack/react-query'
import { getEventGroupsFromRoot, getGroupHighlights } from '../api/groups'
import { sportsOfferingQueryKeys } from './keys'
import { getEventsBySportTermKey } from '../api/events'
import { getKambiBetOffersByIds } from '../api/betOffers'

export const getEventGroupsFromRootQuery = queryOptions({
  queryFn: getEventGroupsFromRoot,
  queryKey: sportsOfferingQueryKeys.EventGroupsFromRoot,
  refetchOnWindowFocus: false,
  staleTime: 1_000 * 60 * 2, // 2min
})

export const getEventsBySportTermKeyQuery = (sport: string) =>
  queryOptions({
    queryFn: () => getEventsBySportTermKey(sport),
    queryKey: sportsOfferingQueryKeys.EventsForSport(sport),
    refetchOnWindowFocus: false,
    staleTime: 1_000 * 60 * 2, // 2min
  })

export const getGroupHighlightsQuery = queryOptions({
  queryFn: getGroupHighlights,
  queryKey: sportsOfferingQueryKeys.EventGroupHighlights,
  refetchOnWindowFocus: false,
  staleTime: 1_000 * 60 * 2, // 2min
})

export const getBetOffersByIds = (betOfferIds: number[]) =>
  queryOptions({
    queryKey: [sportsOfferingQueryKeys.BetOffersByIds, betOfferIds],
    queryFn: () => getKambiBetOffersByIds({ betOfferIds }),
    staleTime: 1_000 * 60 * 10, // 10min
  })
